import { Component, Input } from '@angular/core';

export type LegalPageKind = 'privacy' | 'terms';

@Component({
  selector: 'app-legal-page',
  templateUrl: './legal-page.component.html',
})
export class LegalPageComponent {
  @Input({ required: true }) page!: LegalPageKind;

  protected get title(): string {
    return this.page === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions';
  }

  protected get intro(): string {
    if (this.page === 'privacy') {
      return 'How Pavillion Properties handles information shared through this website and inquiry forms.';
    }

    return 'The basic terms for using the Pavillion Properties website and submitting property inquiries.';
  }
}
